import ImageFactory from '../../../adapters/cloudinary/ImageFactory';

export const roundUpTheSize = (width) => {
    return Math.floor(width / 100) * 100 + 100;
}

export const getBackgroundImage = (contentImageId, width, transformations, format) => {
    if (contentImageId) {
        return `url(${ImageFactory.buildContentfullImageUrlByWidth(contentImageId, width, transformations, format)})`
    }
}
